import { create } from "zustand";

const useAppState = create((set) => ({
  impersonation: { impersonating: false },
  startImpersonating: (company) => set(() => ({ impersonation: { impersonating: true, ...company } })),
  stopImpersonating: () => set(() => ({ impersonation: { impersonating: false } })),
}));

export default useAppState;
